import styled from 'styled-components';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Tooltip from 'react-bootstrap/Tooltip';
import Form from 'react-bootstrap/Form';
import Autocomplete from "react-google-autocomplete";

export const Columns = styled.div`
    display: grid;
    grid-template-columns: 30% 70%;
    margin-top: 110px;
    margin-bottom: 50px;
    
    @media only screen and (max-width: 1100px) {
        display: flex;
        flex-direction: column;        
    }
`;

export const SideImage = styled.img`
    width: 100%;
    height: 100%;

    @media only screen and (max-width: 1100px) {
        display: none;
    }
`

export const InputPageWrapper = styled.div`
    display: grid;
    padding: 1% 3%;
    grid-template-columns: 33% 33% 33%;
    column-gap: 30px;
    row-gap: 50px;
    grid-template-rows: 30px 75x 75x 75x 75x 75x 75x 125px 125px 125px;
    font-size: 2rem;
    margin-right: 6%;
    grid-column: 2;
    margin-left: 6%;

    @media only screen and (max-width: 1100px) {
        display: flex;
        flex-direction: column;
        align-items: left;
        justify-content: space-around;
        row-gap: 40px;
        margin-left: 0%;
        margin-right: 0%;
        
    }
`;

export const InputPageTitle = styled.h1`
    font-size: 3rem;
    color: ${props => props.theme.evTeal};
    grid-row: 1 ;
    grid-column: 1 / span 3;
    text-align: left;
`;

export const InputPageQuestion = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    grid-row: ${props => props.row} / span 1;
    grid-column: ${props => props.column}/ span ${props => props.span ? props.span : 1};
`;

export const InputPageQuestionText = styled.span`
    font-size: 1.5rem;
    color: ${props => props.theme.voltBlue};
    display: inline-block;
    text-align: left;
    margin-bottom: 10px;
    vertical-align: top;
`;

export const SubmitButton = styled.button`
    background-color: ${props => props.theme.evTeal};
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    grid-row: ${props => props.row} / span 1;
    grid-column: ${props => props.column}/ span ${props => props.span ? props.span : 1};
    width: 200px;
    height: 50px;
    align-self: center;
    font-size: 1.5rem;

    &:hover {
        background-color: ${props => props.theme.eLime};
    }
    
    &:disabled {
        background-color: #b3b3b3;
        cursor: not-allowed;
    }
`;

export const BasicButton = styled(Button)`
    background-color: ${props => props.selected ? props.theme.ecoMint : 'white'};
    border: 2px solid ${props => props.theme.ecoMint};
    height: 100%;
    border-radius: 8px;
    width: ${props => props.width};
    font-size: 1rem;

    &:hover {
        background-color: ${props => props.theme.ecoMint};
        cursor: pointer;
    }
    &:focus {
        // background-color: ${props => props.theme.ecoMint};
    }
    @media only screen and (max-width: 1100px) {
        width: 100%;
        margin-right: 5px;
    }


`;

export const BasicButtonGroup = styled(ButtonGroup)`
    display: flex;
    justify-content: space-between;
    width: ${props => props.width};
    height: 50px; 

    @media only screen and (max-width: 1100px) {
        height: 75px;
        width: 100%;
    }

`;

export const StyledTooltip = styled(Tooltip)`
    background-color: ${props => props.theme.ecoMint};
    font-size: 1rem;
    padding: 1rem;
    border-radius: 5px;
    width: 250px;
`;

export const StyledOverlayTrigger = styled.span`
    font-size: 0.75rem;
    border: 2px solid ${props => props.theme.voltBlue};
    color: ${props => props.theme.voltBlue};
    width: 15px;
    height: 15px;
    width: 15px;
    border-radius: 50%;
    display: inline-block;
    text-align: center;
    margin-left: 7px;
    margin-top: 2px;
    vertical-align: top;
`;

export const StyledSelect = styled(Form.Select)`
    background-color: white;
    border: 2px solid ${props => props.theme.ecoMint};
    height: 40px;
    border-radius: 8px;
    width: 80%;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    font-size: 1rem;
    padding: 0 10px;

    &:hover {
        cursor: pointer;
    }
    &:focus {
        border: 2px solid ${props => props.theme.ecoMint};
    }
`;

export const StyledSelectItem = styled.option`
    background-color: white;
    border: 2px solid ${props => props.theme.ecoMint};
    height: 40px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    font-size: 1rem;
    color: black;
    padding: 0 10px;

    &:hover {
        cursor: pointer;
    }
`;

export const StyledTextInput = styled(Form.Control)`
    background-color: white;
    border: 2px solid ${props => props.theme.ecoMint};
    border-radius: 8px;
    width: ${props => props.width ? props.width : '80%'};
    height: ${props => props.height ? props.height : '40px'};
    display: ${props => props.display ? props.display : 'flex'};
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    font-size: 1rem;
    padding: 0 10px;

    &:disabled {
        background-color: #d9d9d9;
        border: 2px solid #d9d9d9;
        cursor: not-allowed;
    }

    @media only screen and (min-width: 1101px) {
        ${props => props.question && props.question == "role2" ? 'display: none' : null};
    }
    
    @media only screen and (max-width: 1100px) {
        ${props => props.question && props.question == "role1" ? 'display: none' : null};

    }
`;

export const StyledLabel = styled.label`
  display: flex;
  cursor: pointer;
  margin-right: 10px;
`;

export const StyledSwitch = styled.div`
  width: 32px;
  height: 32px;
  background: #b3b3b3;
  border-radius: 5px;

  &:before {
    transition: 300ms all;
    content: " ";
    width: 28px;
    height: 28px;
    border-radius: 35px;

    background: white;
  }
`;

export const StyledInput = styled.input`
  opacity: 0;
  width: 0;

  &:checked + ${StyledSwitch} {
    background: ${props => props.theme.evTeal};
  }
`;

export const StyledCheckbox = styled.input`
    width: 20px;
    height: 20px;
    margin: 0 10px;
    accent-color: ${props => props.theme.evTeal};
    align-self: center;
    content: '';
`;

export const StyledParagraph = styled.div`
    font-size: 1rem;
    color: ${props => props.theme.voltBlue};
    text-align: left;
    grid-row: 2 ;
    grid-column: 1 / span 3;

    div {
    margin: 1rem 0;
    }

    b {
    font-weight: bold;
    }

`;

export const StyledPlaceInput = styled(Autocomplete)`
    background-color: white;
    border: 2px solid ${props => props.theme.ecoMint};
    height: 40px;
    border-radius: 8px;
    width: ${props => props.width ? props.width : '80%'};
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    font-size: 1rem;
    padding: 0 10px;
`;

export const WarningText = styled.p`
    color: red;
    font-size: 1rem;
    width: 100%;
    text-align: left;
`;

export const InputRow = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin-bottom: 20px;
`;

export const CheckboxText = styled.span`
    font-size: 1.25rem;
    color: ${props => props.theme.voltBlue};
    display: inline-block;
    text-align: left;
    vertical-align: top;
    width: 100%;
`;